import React, { useEffect, useState } from 'react';
import api from '../api';

const AdminDashboard = () => {
    const [users, setUsers] = useState([]);
    const [message, setMessage] = useState('');

    const handleRoleChange = async (uid, newRole) => {
        setMessage('');
        try {
            await api.post('/auth/set-role', { uid, role: newRole });
            setUsers((prev) =>
                prev.map((u) => (u.uid === uid ? { ...u, role: newRole } : u))
            );
            setMessage('Rôle mis à jour');
        } catch (err) {
            setMessage("Erreur lors de la mise à jour du rôle");
        }
    };

    const handleDelete = async (uid) => {
        setMessage('');
        try {
            await api.delete(`/auth/users/${uid}`);
            setUsers((prev) => prev.filter((u) => u.uid !== uid));
            setMessage('Utilisateur supprimé');
        } catch (err) {
            setMessage("Erreur lors de la suppression de l'utilisateur");
        }
    };

    const handleDeleteData = async (target) => {
        setMessage('');
        const labels = {
            candidats: 'tous les candidats',
            offres: "toutes les offres",
            all: 'toutes les données (candidats et offres)'
        };

        if (target === 'all') {
            if (!window.confirm('Voulez-vous vraiment supprimer toutes les données ?')) return;
            if (!window.confirm('Confirmez-vous la suppression définitive de toutes les données ?')) return;
        } else {
            if (!window.confirm(`Supprimer ${labels[target]} ?`)) return;
        }

        try {
            await api.delete('/admin/data', { params: { target } });
            setMessage('Données supprimées');
        } catch (err) {
            setMessage('Erreur lors de la suppression des données');
        }
    };

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const res = await api.get('/auth/users');
                setUsers(res.data);
            } catch (err) {
                console.error('Erreur lors de la récupération des utilisateurs', err);
            }
        };
        fetchUsers();
    }, []);

    return (
        <div className="max-w-2xl mx-auto">
            <h1 className="text-2xl mb-4">Administration</h1>
            {message && <p className="mb-4">{message}</p>}
            <p className="mb-4 text-sm text-gray-700">
                Les utilisateurs sans rôle sont affichés comme « Nouveau ». Assignez-leur le rôle « User » pour leur donner accès.
            </p>
            {users.length > 0 && (
                <table className="min-w-full border">
                    <thead>
                        <tr>
                            <th className="border px-2 py-1">Nom</th>
                            <th className="border px-2 py-1">UID</th>
                            <th className="border px-2 py-1">Email</th>
                            <th className="border px-2 py-1">Rôle</th>
                            <th className="border px-2 py-1">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map((u) => (
                            <tr key={u.uid}>
                                <td className="border px-2 py-1">
                                    {u.display_name || 'Sans nom'}
                                </td>
                                <td className="border px-2 py-1">{u.uid}</td>
                                <td className="border px-2 py-1">{u.email || 'Sans email'}</td>
                                <td className="border px-2 py-1">
                                    <select
                                        value={u.role || ''}
                                        onChange={(e) => handleRoleChange(u.uid, e.target.value)}
                                        className="p-1 text-black"
                                    >
                                        <option value="" disabled>
                                            Nouveau
                                        </option>
                                        <option value="admin">Admin</option>
                                        <option value="user">User</option>
                                    </select>
                                </td>
                                <td className="border px-2 py-1">
                                    <button
                                        onClick={() => handleDelete(u.uid)}
                                        className="text-red-500"
                                    >
                                        Supprimer
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
            <div className="mt-8 space-y-2">
                <h2 className="text-xl mb-2">Maintenance des données</h2>
                <div className="flex flex-col gap-2">
                    <button
                        onClick={() => handleDeleteData('candidats')}
                        className="bg-red-600 text-white px-4 py-2 rounded"
                    >
                        Supprimer tous les candidats
                    </button>
                    <button
                        onClick={() => handleDeleteData('offres')}
                        className="bg-red-600 text-white px-4 py-2 rounded"
                    >
                        Supprimer toutes les offres
                    </button>
                    <button
                        onClick={() => handleDeleteData('all')}
                        className="bg-red-700 text-white px-4 py-2 rounded"
                    >
                        Supprimer toutes les données
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AdminDashboard;
